App.addModule(function(app) {

    app.on('loaded', () => {
	    
        if (app.get('app.request.path') === 'checkout/onepage/success') {
            app.dispatchEvent('checkout:sale', app.get('checkout.order'))
            return
        }

        if (app.get('app.request.path') !== 'erp/checkout/index') {
            return
        }
	    
	    /*
	     * Cache DOM and Sections
	     */
	    var form = $('#checkout-form'),
		    sections = {},
		    sectionList	= [];

	    $('[data-section]').each(function(i, element) {
		    
		    var $el = $(element),
			    name = $el.data('section');
		    
		    sections[name] = {
			    el: $el,
			    name: name,
			    content: $el.find('.checkout-section-content'),
			    loader: $el.find('.loader:not(#place-order-loader)')
		    };
		    
		    sectionList.push(name)
	    });
	    
	    
		const checkout = {
			hold: false,
			form: form[0],
			placeOrder: () => {
				
				$.post({
			        url: app.getUrl('erp/checkout/placeOrder'),
			        data: form.serializeArray(),
			        dataType: 'json'
		        })
		        .done(function(data) {
			        
			        if (data.error_msg) {
				        app.dispatchEvent('checkout:placeOrderError', data.error_msg);
			        }
			        else if (data.redirect_url) {
				        window.location = data.redirect_url;
				        return;
			        }
			        
			        app.dispatchEvent('checkout:placeOrderEnd');
		        })
		        .fail(function(response) {
			        onResponseFailure(response);
			        app.dispatchEvent('checkout:placeOrderEnd');
		        });
			}
		}
		
	    /*
	     * Init Validator
	     */
	    form.off('submit');
	    
        var validator = app.initFormValidator(form[0], {
        	
		    submitHandler: function() {
			    
				checkout.hold = false
				checkout.data = new FormData(checkout.form)
				
        		app.dispatchEvent('checkout:placeOrder', checkout);
        		
        		if (checkout.hold) {
        			return;
        		}
        		
            	app.dispatchEvent('checkout:placeOrderStart');
				
				checkout.placeOrder()
		    }
	    });
        
	    /*
	     * Response Failure Handler
	     */
	    function onResponseFailure(response) {
		    
		    app.log('OsCheckout Response Failure: ' + response.status);
		    
		    if (response.status == 403) { // if cart has expired
			    window.location = app.getUrl('checkout/cart');
		    }
	    }
		
	    /*
	     * Post Data and Reload Sections
	     */
	    function post(section, cb) {
		    
		    var i = sectionList.indexOf(section);
		    
		    var reload = sectionList.slice(i+1);
		    
		    app.dispatchEvent('checkout:loadSectionStart', [reload]);
		    
		    var res = false;
		    
		    var formData = form.serializeArray();
		    
		    reload.forEach(name => {
			    formData.push({name: 'section[]', value: name});
		    })
		    
		    $.post({
			    url: app.getUrl('erp/checkout/processPost'),
			    data: formData,
			    dataType: 'json'
		    })
		    .done(function(data) {
			    
			    if (data.error_msg) {
				    // hide errors from customer until they place order
			    }
			    
			    reload.forEach(name => {
				    sections[name].content.html(data[name].html);
			    })
			    
			    cb && cb();
			    
			    res = true;
			    
			    if (res) {
				    app.dispatchEvent('checkout:completeSection', section);
			    }
		    })
		    .fail(onResponseFailure)
		    .always(function() {
			    app.dispatchEvent('checkout:loadSectionEnd', [reload]);
		    });
		    
		    return res;
	    }
	    
	    
	    /*
	     * Loaders etc.
	     */
	    
	    app
        	.on('checkout:loadSectionStart', function(s) {
        		$.each(s, function(i, name) {
        			sections[name].el.hide();
        			sections[name].loader.show();
        		})
		    })
        	.on('checkout:loadSectionEnd', function(s) {
        		$.each(s, function(i, name) {
				    sections[name].el.show();
				    sections[name].loader.hide();
			    });
		    })
		    .on('checkout:placeOrderError', function(msg, field) {
			    
			    if (field) {
				    obj = {}
				    obj[field] = msg
				    validator.showErrors(obj);
			    }
			    else {
				    app.alert(msg, 'warning');
				    post('payment_method'); // reload cart
			    }
		    })
		    .on('checkout:placeOrderStart', function() {
			    
			    $('#place-order-button').siblings('.alert').remove();
			    
			    if (BS.isScreenSmMin()) {
				    $('#place-order-loader').show();
			    }
			    else {
				    $('#place-order-button').button('loading');
			    }
		    })
		    .on('checkout:placeOrderEnd', function() {
			    
			    if (BS.isScreenSmMin()) {
				    $('#place-order-loader').hide();
			    }
			    else {
				    $('#place-order-button').button('reset');
			    }
		    });
	    
	    
	    /*
	     * Mobile View Section Handling
	     */
	    
	    function open(section) {
		    
		    if (BS.isScreenXs() && section) {
			    
			    $('[data-section]').removeClass('current');
			    $('[data-section='+ section +']').addClass('current')
			    app.dispatchEvent('checkout:openSection', section);
        	}
	    }
	    
	    $('[data-section-submit]').click(function(event) {
		    
		    event.preventDefault();
		    
		    var button = $(event.target);
		    
		    var section = button.data('section-submit');
		    
		    var inputs = $('[data-section="'+ section +'"] input');
		    
		    if (inputs.length && !inputs.valid()) {
			    validator.focusInvalid();
			    return;
		    }
		    
		    button.button('loading');
		    
		    post(section, function() {
			    open(button.data('section-open'));
			    button.button('reset');
		    });
	    });
	    
	    $('[data-section-open]').click(function(event) {
		    
		    var button = $(event.target);
		    
		    if (button.data('section-submit')) {
			    return;
		    }
		    
		    open(button.data('section-open'));
	    });
	    
	    
	    /*
	     * Address Handling
	     */
	    
	    $('.fg-address-id input').change(function(event) {
		    
		    if (!post('address')) {
			    event.preventDefault();
		    }
	    });
	    
	    $('.customer-group-radio').change(function(event) {
		    
		    if (event.target.value == 'business') {
			    $('.fg-company').show();
		    }
		    else {
			    $('.fg-company').hide();
		    }
		    
		    if (form.find('input[name="shipping_method"]').val()) {
			    post('shipping_method');
		    }
	    });
	    
	    if ($('.customer-group-radio[value=business]').prop('checked')) {
		    $('.fg-company').show();
	    }
	    else {
		    $('.fg-company').hide();
	    }
	    
	    if (!$('#use-shipping-address').prop('checked')) {
		    $('#shipping-address').hide();
	    }
	    
	    $('#use-shipping-address').change(function() {
		    
		    if ($('#use-shipping-address').prop('checked')) {
			    $('#shipping\\:country_id').val($('#billing\\:country_id').val());
		    }

		    $('#shipping-address').toggle();

		    if ($('#shipping\\:country_id').val() != $('#billing\\:country_id').val()) {
			    post('address');
		    }
	    });
	    
	    $('#billing\\:telephone').blur(function(event) {
		    $('#shipping\\:telephone').val($(this).val()).change();
	    });
	    
	    $('#billing\\:country_id').change(function(event) {
		    
		    if (app.get('checkout.cart.is_virtual')) {
			    post('address');
		    }
		    else {
			    if (!$('#use-shipping-address').prop('checked')) {
				    $('#shipping\\:country_id').val($(this).val()).change();
			    }
		    }
	    });
	    
	    $('#billing\\:postcode').change(function(event) {
		    if (!$('#use-shipping-address').prop('checked')) {
			    $('#shipping\\:postcode').val($(this).val()).change();
		    }
	    });
	    
	    $('#shipping\\:country_id').change(function(event) {
		    post('address');
	    });

	    $('#shipping\\:postcode').change(function(event) {
		    post('address');
	    });
	    
	    app.on('checkout:loadSectionStart', function() {
		    
		    var sphone = $('#shipping\\:telephone');
		    
		    if ('' == sphone.val()) {
			    sphone.val($('#billing\\:telephone').val());
		    }
		    
		    if ($('#customer-group-b2c').prop('checked')) {
			    $('#billing\\:company').val('');
			    $('#shipping\\:company').val('');
		    }
	    });
	    
	    
	    /*
	     * Shipping Method Handling
	     */
	    
	    $('#checkout-section-shipping-method')
		    .on('show.bs.tab', 'a[data-toggle="tab"]', function(event) {
			    
			    if (!$('[data-section="address"] input').valid()) {
				    event.preventDefault();
				    validator.focusInvalid();
				    return;
			    }
			    
			    var tab = $(this);
			    
			    if (tab.parent().hasClass('active')) {
				    return;
			    }
			    
			    var input = tab.children('input[name="shipping_method"]');
			    
			    if (input.val() == 'flex_service' && $('#flex-service-plus').prop('checked')) {
				    input = $('#s_method_flex_service_plus input');
			    }
			    
			    input.prop('checked', true).change();
		    })
		    .on('change', 'input[name="shipping_method"]', function() {
			    
			    var method = String($(this).val());
			    
			    app.dispatchEvent('checkout:setShippingMethod', method);
			    
			    if (this.checked) {
				    post('shipping_method');
			    }
		    })
		    .on('change', '#flex-service-plus', function() {
			    if (this.checked) {
				    $('#s_method_flex_service_plus input').prop('checked', true).change();
			    }
			    else {
				    $('#s_method_flex_service input').prop('checked', true).change();
			    }
		    });

	    function observeServicePlus() {
		    
		    if ($('#s_method_flex_service_plus input').prop('checked')) {
			    $('#flex-service-plus').prop('checked', true)
			    $('#s_method_flex_service a').tab('show')
		    }
	    }
	    
	    app.on('checkout:loadSectionEnd', observeServicePlus)
	    
	    observeServicePlus()
	    
	    var shippingMethod = $('input[name=shipping_method]:checked').val()
		    
	    if (shippingMethod) {
            app.dispatchEvent('checkout:setShippingMethod', shippingMethod)
        }
	    
	    /*
	     * Payment Method Handling
	     */		
		app.on('checkout:activatePaymentMethod', method => {
			
			var $payment = $('#payment-method-' + method);
		    
		    if ($payment.hasClass('active')) {
			    return this;
		    }
		    
		    $payment.siblings().removeClass('active');
		    $payment.addClass('active');
		    
		    $payment.find('.payment-method-form').show();
		})
		
		app.on('checkout:disablePaymentMethod', method => {
		    
		    $method = $('#payment-method-'+ method);
		    
		    $method.removeClass('active');
		    $method.find(':radio').attr('disabled', true).prop('checked', false);
		})
		
	    $('#checkout-section-payment-method').on('change', 'input[name="payment[method]"]', function(event) {
		    post('payment_method')
            var paymentMethod = $(this).val()
			app.dispatchEvent('checkout:activatePaymentMethod', paymentMethod)
            app.dispatchEvent('checkout:setPaymentMethod', paymentMethod)
	    })
	    
	    app.on('checkout:loadSectionEnd', sections => {
		    sections.includes('payment_method') && app.dispatchEvent('checkout:activatePaymentMethod', $('.payment-method-container :radio:checked').val())
	    })

        var paymentMethod = $('.payment-method-container :radio:checked').val()
        
        if (paymentMethod) {
	        app.dispatchEvent('checkout:activatePaymentMethod', paymentMethod)
            app.dispatchEvent('checkout:setPaymentMethod', paymentMethod)
        }
	    
        $('#checkout-section-payment-method').on('click', '#remove-payment', function() {
            $(this).append('<input type="hidden" name="payment[method]" value=""/>')
            post('shipping_method')
        })
    })
})
